<div class="p-8">
  <h1 class="text-3xl font-bold text-gray-900 mb-6">Settings</h1>

  <app-spinner *ngIf="loading"></app-spinner>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow p-6">
    <app-site-form 
      [isEdit]="true"
      [showUrl]="false"
      [showCancel]="false"
      [siteId]="siteId"
      [siteUrl]="siteUrl"
      [initialData]="currentSiteData"
      (success)="onSuccess($event)"
      (error)="onError($event)">
    </app-site-form>
    
    <!-- Success Message -->
    @if (successMessage) {
      <div class="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
        {{ successMessage }}
      </div>
    }

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
        {{ errorMessage }}
      </div>
    }
  </div>
</div>